import { useTranslation } from "react-i18next";

function NoFilterProject() {

  const {t}=useTranslation();
  return (
    <div className="w-full h-full p-8 ">
      <div
        className={`w-full px-5 h-full flex overflow-auto justify-center items-center border rounded-lg`}
      >
       {t("No results match your filter criteria")}
      </div>
    </div>
  );
}

export default NoFilterProject;
